<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      経験・転職意欲
    </Header>
    <CustomValidationObserver
      tag="div"
      class="pt-2 pb-4 mx-3"
      v-slot="{ handleSubmit }"
    >
      <StepBar :maxValue="4" :currentValue="4" class="mb-3" />
      <BusinessInfo v-model="inputValues" />
      <BottomFormActionButtons
        submitButtonText="登録する"
        skipButtonText="スキップする"
        @submit="handleSubmit(onSubmit)"
        @skip="onClickSkip"
      />
    </CustomValidationObserver>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BusinessInfo from "@/components/organisms/common/BusinessInfo.vue";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { authStore } from "@/store/auth";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { BusinessInfoInputValues } from "@/types/form/BusinessInfoInputValues";
import BottomFormActionButtons from "@/components/organisms/register/BottomFormActionButtons.vue";
import StepBar from "@/components/molecules/other/StepBar.vue";
import { routerPush } from "@/utils/routerPush";

type WorkStyleType = "latest" | "preferred";

@Component({
  components: {
    FeatherIcon,
    BusinessInfo,
    Header,
    BlockBack,
    BottomFormActionButtons,
    StepBar
  }
})
export default class RegisterBusinessInfo extends Vue {
  inputValues: BusinessInfoInputValues = {
    experiences: [{ service: null, stint: null }],
    prComment: "",
    latestWorkStyle: [],
    preferredWorkStyle: [],
    jobChange: null
  };

  created() {
    this.initInput();
  }

  initInput() {
    if (!authStore.user) return;
    if (authStore.user.experiences.length > 0) {
      this.inputValues.experiences = authStore.user.experiences.map(v => ({
        stint: v.stint,
        service: v.service
      }));
    }
    this.inputValues.prComment = authStore.user.prComment;
    this.inputValues.jobChange = authStore.user.jobChange;
    this.inputValues.latestWorkStyle = this.getWorkStyle("latest") || [];
    this.inputValues.preferredWorkStyle = this.getWorkStyle("preferred") || [];
  }

  async onSubmit() {
    const styles = (style: number[], type: WorkStyleType) =>
      style.map(value => ({ type, style: value }));
    const workStyle = [
      ...styles(this.inputValues.latestWorkStyle, "latest"),
      ...styles(this.inputValues.preferredWorkStyle, "preferred")
    ];
    const experiences = this.inputValues.experiences.map(v => ({
      service: v.service!,
      stint: v.stint!
    }));

    this.$loading.show();
    try {
      const body = {
        prComment: this.inputValues.prComment,
        jobChange: this.inputValues.jobChange || undefined,
        experiences,
        workStyle
      };
      await authStore.registerUserInfo(body);
      sendAdjustEvent("FINISH_INPUT_JOB_CHANGE");
      sendFirebaseCustomEvent("finish_input_job_change", {
        session_id: authStore.sessionId || "unknown"
      });
      await routerPush(this, { name: "RegisterFinishSignup" });
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async onClickSkip() {
    sendAdjustEvent("SKIP_INPUT_JOB_CHANGE");
    sendFirebaseCustomEvent("skip_input_job_change", {
      session_id: authStore.sessionId || "unknown"
    });
    await routerPush(this, { name: "RegisterFinishSignup" });
  }

  getWorkStyle(workType: WorkStyleType) {
    if (!authStore.user) return;
    return authStore.user.workStyle
      .filter(w => w.type === workType)
      .map(w => w.style);
  }
}
</script>
